<template>
  <Container style="height: 80vh" class="bg-white h-screen text-center py-10 justify-center items-center flex flex-col px-4">
    <h2 class="font-gotham-medium font-bold text-xl pt-2">Harbour ISP is now Nexee. Customers can use existing log in details for your internet account.</h2>
    <h2 class="font-gotham-medium font-bold text-xl pt-4">
      You will be redirected to Nexee in 20 seconds or <a class="underline" href="https://nexee.au?from=his">click here.</a>
    </h2>
  </Container>
</template>

<script lang="ts" setup>
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import router from '@/router';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '@/services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Data.
// Event handlers.
const nexeeRedirect = async () => {
  if (brandService.getName() === Brand.HIS) {
    setTimeout(() => {
      window.location.href = 'https://nexee.au?from=his';
    }, 22000);
  } else {
    router.push('/');
  }
};

nexeeRedirect();
</script>
